import {
  FetchResult,
  gql,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationResult,
  TypedDocumentNode,
  useMutation,
} from '@apollo/client';
import { DeviceInput, UpdateDeviceMutation, UpdateDeviceMutationVariables } from '../../generated/graphql';

import { DEVICE_FIELDS, PRODUCT_FIELDS } from '../../queries';

export const updateDeviceMutation: TypedDocumentNode<UpdateDeviceMutation, UpdateDeviceMutationVariables> = gql`
  ${PRODUCT_FIELDS}
  ${DEVICE_FIELDS}

  mutation UpdateDevice($maLoId: ID!, $deviceId: ID!, $input: DeviceInput!) {
    updateDevice(maLoId: $maLoId, deviceId: $deviceId, input: $input) {
      ...DeviceFields
    }
  }
`;

export function useUpdateDeviceMutation(
  options?: MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>,
): [
  (
    maLoId: string,
    deviceId: string,
    config: DeviceInput,
    options?: MutationFunctionOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>,
  ) => Promise<FetchResult<UpdateDeviceMutation>>,
  MutationResult<UpdateDeviceMutation>,
] {
  const [update, response] = useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(
    updateDeviceMutation,
    options,
  );

  return [
    (maLoId, deviceId, input, opts) =>
      update({
        ...opts,
        variables: {
          maLoId,
          deviceId,
          input,
        },
      }),
    response,
  ];
}
